function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import FormContainerAbstract from 'components/FormContainerAbstract';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import Button from 'components/Form/Button';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Modal from 'components/Modal';
import Account from 'modules/Account';
import App from 'modules/App';
import messages from '../../messages';
import * as constants from '../../constants';
import styles from '../ModalCommon.pcss';
class NotificationsSettingsModal extends FormContainerAbstract {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors } = props;
        if (isInProgress !== state.isInProgress && isInProgress) {
            return {
                isInProgress: true
            };
        }
        if (hasErrors && state.isInProgress) {
            return {
                isInProgress: false
            };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { isInProgress, hasErrors } = this.props;
        if (prevProps.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            this.onClose();
            this.props.onFetchNotificationsSettings();
        }
        if (this.props.openModalId && prevProps.openModalId !== this.props.openModalId && this.props.openModalId === constants.NOTIFICATIONS_SETTINGS_MODAL) {
            this.onPopulate();
        }
    }
    onPopulate() {
        const notificationsObject = this.props.notificationsSettings.reduce((acc, { notificationConfigId, allowNotification })=>{
            acc[notificationConfigId.toString()] = allowNotification ? 'true' : 'false';
            return acc;
        }, {});
        this.onSetValues(notificationsObject);
    }
    async onClose() {
        await this.props.onCloseModal();
        this.props.onClearForm();
        this.setState({
            isInProgress: false
        });
    }
    onSubmit() {
        this.props.onFormProcessing();
        const values = get(this.props.formValues, 'values');
        this.props.onSubmit(values);
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.cancel,
                        className: "btn--block",
                        isInProgress: this.state.isInProgress,
                        onClick: this.props.onCloseModal
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: messages.buttons.saveChanges,
                        className: "btn--block btn--filled",
                        isInProgress: this.state.isInProgress,
                        type: "submit"
                    })
                })
            ]
        });
    }
    renderNotification({ allowNotification, descriptionKey, notificationConfigId }) {
        const name = get(this.props.localizationResources, `${descriptionKey}.value`, descriptionKey);
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: notificationConfigId.toString(),
            formValues: this.props.formValues,
            className: "mb-5 pb-1",
            children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                inputValue: "true",
                value: allowNotification ? 'true' : 'false',
                onChange: (input)=>this.onSetValue(input),
                labelMessage: name
            })
        }, `${notificationConfigId}-notification-checkbox`);
    }
    renderNotifications() {
        const { notificationsSettings } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            children: notificationsSettings.map((notification)=>/*#__PURE__*/ _jsx("div", {
                    children: this.renderNotification(notification)
                }, `${notification.notificationConfigId}-notification`))
        });
    }
    render() {
        const { notificationsSettings } = this.props;
        if (!notificationsSettings) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.NOTIFICATIONS_SETTINGS_MODAL,
            openModalId: this.props.openModalId,
            styleModifier: "md",
            headerMessage: messages.headers.notificationsSettings,
            onClose: this.props.onCloseModal,
            isStopPropagationOnClickModal: true,
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: styles['content-header'],
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.notifyMeWhen))
                }),
                /*#__PURE__*/ _jsxs(Form, {
                    className: styles.form,
                    onSubmit: ()=>this.onSubmit(),
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.container,
                            children: this.renderNotifications()
                        }),
                        this.renderActions()
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isInProgress: false
        };
    }
}
_define_property(NotificationsSettingsModal, "propTypes", {
    // Implicit props
    notificationsSettings: PropTypes.array,
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    formValues: PropTypes.object,
    openModalId: PropTypes.string,
    // Implicit actions
    onCloseModal: PropTypes.func,
    onClearForm: PropTypes.func
});
const notificationsSettingsFormSelector = App.selectors.formSelector(constants.NOTIFICATIONS_SETTINGS_FORM);
const mapStateToProps = (state)=>({
        openModalId: App.selectors.modal(state),
        notificationsSettings: Account.selectors.activeNotificationsSettings(state),
        localizationResources: App.selectors.localizationResources(state),
        formValues: notificationsSettingsFormSelector(state),
        isInProgress: Account.selectors.isUpdateNotificationsSettingsInProgress(state),
        hasError: Account.selectors.hasUpdateNotificationsSettingsErrors(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.NOTIFICATIONS_SETTINGS_FORM;
    return {
        onSubmit: (notificationsSettings)=>dispatch(Account.actions.updateNotificationsSettings(notificationsSettings)),
        onFetchNotificationsSettings: ()=>dispatch(Account.actions.fetchNotificationsSettings()),
        onCloseModal: ()=>dispatch(App.actions.closeModal()),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedNotificationsSettingsModal = connect(mapStateToProps, mapDispatchToProps)(NotificationsSettingsModal);
export default withStyles(styles)(ConnectedNotificationsSettingsModal);
